export default function getFirstLetter(string){
    return string?.charAt(0).toUpperCase() || '-';
}